<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" :inline="true" size="mini"  ref="ruleForm" label-width="100px"
      class="demo-ruleForm">
      <el-form-item label="ID" prop="id">
        <el-input v-model="ruleForm.id" disabled></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="name">
        <el-input v-model="ruleForm.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="组件名" prop="compName">
        <el-input v-model="ruleForm.compName" disabled></el-input>
      </el-form-item>
      <el-form-item label="组件类型" prop="type">
        <el-input v-model="ruleForm.type" disabled></el-input>
      </el-form-item>
      <el-form-item label="数据展示时间段" prop="id" required>
        <!-- <el-input v-model="ruleForm.statDate" :disabled="dialogType === 'detail'"></el-input> -->
        <el-select v-model="ruleForm.statDate" placeholder="请选择" :disabled="dialogType === 'detail'">
          <el-option v-for="(item, index) in insideTimeList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-input v-model="ruleForm.createDate" disabled></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MyContent',
  props: {
    ruleForm: {
      type: Object
    },
    dialogType: String
  },
  data() {
    return {
      rules: {
        statDate: [{
          required: true,
          message: '请选择数据展示时间段',
          trigger: 'blur'
        }]
      },
      insideTimeList: []
    };
  },
  methods: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    }),
    async getInsideTime() {
      const { bean } = await this.$services.post({
        type: 'ASSESS_FORECAST',
        url: 'getInsideTime',
        params: {
          depCode: this.userInfor().depCode
        }
      });
      bean.forEach(val => {
        this.insideTimeList.push({
          value: val.id,
          label: val.dicName
        });
      });
    },
  },
  mounted() {
    this.getInsideTime();
  }
};
</script>

<style lang="scss" scoped>
  .demo-ruleForm {
    margin: 0 auto;
    text-align: center;
    .el-input,
    .el-select,
    .el-cascader {
      width: 250px;
      height: 32px;

      input {
        height: 32px;
      }
    }

    .el-textarea {
      width: 250px;
    }
  }

</style>
